import script from "./TheLoadingSpinner.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheLoadingSpinner.vue?vue&type=script&lang=ts&setup=true"

import "./TheLoadingSpinner.vue?vue&type=style&index=0&id=9ab34966&lang=css"

const __exports__ = script;

export default __exports__